import { CursorPaging, Hotline, MobileNetworkDisplay } from '@etop/models';
import { HotlineStore } from '@etop/state/shop/hotline/hotline.store';
import { Injectable } from '@angular/core';
import { HotlineApi, HotlinesAPI } from "@etop/api/shop/hotline.api";
import { AuthenticateStore } from "@etop/core";
import { HotlineQuery } from './hotline.query';

@Injectable({
  providedIn: 'root'
})
export class HotlineService {
  constructor(
    private hotlineApi: HotlineApi,
    private hotlineStore: HotlineStore,
    private hotlineQuery: HotlineQuery,
    private auth: AuthenticateStore
  ) { }

  async getHotlines() {
    this.hotlineStore.setLoading(true);
    try {
      const hotlines: Hotline[] = await this.hotlineApi.getHotlines();
      this.hotlineStore.set(hotlines);
    } catch (e) {
      debug.error('ERROR in getting Hotlines', e);
    }
    this.hotlineStore.setLoading(false);
  }

  async getAllHotlines(doLoading = true, mapUser = true) {
    if (doLoading) {
      this.hotlineStore.setLoading(true);
    }
    try {
      const paging = this.hotlineQuery.paging;
      const filter = this.hotlineQuery.filter;
      const request: HotlinesAPI.GetHotlinesRequest = {
        paging,
        filter,
      };
      const res = await this.hotlineApi.getListHotlines(request);
      let hotlines = res.hotlines;

      hotlines = res.hotlines.map((hotline) => {
        hotline.network_display = MobileNetworkDisplay[hotline.network]
        return hotline;
      });
      this.hotlineStore.upsertMany(hotlines)
      this.setPaging(res?.paging);

      if (this.hotlineQuery.currentUi.paging?.next != "" && this.hotlineQuery.currentUi.paging?.limit == hotlines.length) {
        this.setPaging({
          ...this.hotlineQuery.currentUi.paging,
          after: this.hotlineQuery.currentUi.paging.next,
        });

        return await this.getAllHotlines(doLoading, mapUser)
      }
    } catch (e) {
      debug.error('ERROR in getting Hotlines', e);
    }
    if (doLoading) {
      this.hotlineStore.setLoading(false);
    }
  }

  setPaging(paging: CursorPaging) {
    const ui = this.hotlineQuery.currentUi;
    this.hotlineStore.update({
      ui: {
        ...ui,
        paging,
      },
    });
  }

  setFilter(filter: HotlinesAPI.GetHotlinesFilter) {
    const ui = this.hotlineQuery.currentUi;
    this.hotlineStore.update({
      ui: {
        ...ui,
        filter,
      },
    });
  }

  checkHotLineRequested() {
    const oneDay = 24 * 60 * 60 * 1000;
    const lastRequest = localStorage.getItem('hotlineRequest');
    if (!lastRequest) {
      this.hotlineStore.update({ hotlineRequested: false });
    } else {
      const checkRequested = parseFloat(Date.now().toString()) - parseFloat(lastRequest) < oneDay;
      this.hotlineStore.update({ hotlineRequested: checkRequested });
    }
  }

  hotlineRequest() {
    this.hotlineStore.update({ hotlineRequested: true });
    localStorage.setItem('hotlineRequest', Date.now().toString());
    toastr.success(`Hệ thống đã tiếp nhận yêu cầu mua Hotline của bạn. Chúng tôi sẽ xử lý và liên hệ với bạn trong thời gian sớm nhất.`);
  }

  async updateHotline(hotline_id: string) {
    try {
      await this.hotlineApi.updateHotlineForExtension(hotline_id)
    } catch (e) {
      console.error('ERROR in getting Hotlines', e);
    }
  }
}
